import type { FacilityHit, PersonHit } from "@/components/AlgoliaSearch";
import {
  globalSearchFacilityListItemProps,
  globalSearchPersonListItemProps
} from "@/components/GlobalSearch/entityListItemContent";
import ListItem from "@/components/ListItem/ListItem";

export function renderCreateInteractionPersonHit(hit: PersonHit, select: (hit: PersonHit) => void, query?: string) {
  return (
    <div className="cursor-pointer" onClick={() => select(hit)}>
      <ListItem {...globalSearchPersonListItemProps(hit, query ?? "")} />
    </div>
  );
}

export function renderCreateInteractionFacilityHit(
  hit: FacilityHit,
  select: (hit: FacilityHit) => void,
  query?: string
) {
  return (
    <div className="cursor-pointer" onClick={() => select(hit)}>
      <ListItem {...globalSearchFacilityListItemProps(hit, query ?? "")} />
    </div>
  );
}
